<template lang='pug'>
v-main
  Header(:color="themeColor", :logo="logoBU")
  v-card
    v-tabs(color="white", slider-color="red", left )
      v-tab(
        style='background-color:white !important'
        @click="tableApproval = true; tableHistory = false; tableRejected = false; getData()"
      ) Need Approval
      v-tab(
        style='background-color:white !important'
        @click="tableApproval = false; tableHistory = true; tableRejected = false; getDataHistory()"
      ) Approved
      v-tab(
        style='background-color:white !important'
        @click="tableApproval = false; tableHistory = false; tableRejected = true; getDataRejected()"
      ) Rejected
      //- v-tab(@click="tableApproval=false;tableHistory=false;tableRejected:true;getDataRejected()") Rejected
  IMListApproval(
    v-if="tableApproval",
    :title="title",
    :color="themeColor",
    :listType="listType",
    :dialogType="dialogType",
    :typeTab="getType()",
    :im="getIM()"
  )
  IMListApproval(
    v-if="tableHistory",
    :title="title",
    :color="themeColor",
    :listType="listType",
    :dialogType="dialogType",
    :typeTab="getType()",
    :im="getIM()"
  )
  IMListApproval(
    v-if="tableRejected",
    :title="title",
    :color="themeColor",
    :listType="listType",
    :dialogType="dialogType",
    :typeTab="getType()",
    :im="getIM()"
  )
  //- CookieCard
</template>

<script>
import Header from "../components/HeaderApproval.vue";
import CookieCard from "../components/CookieCard.vue";
import IMListApproval from "../components/IMListApproval.vue";
import * as i18n from "../data/i18n.json";
import axios from "axios";
export default {
  name: "IMApproval",
  components: {
    Header,
    CookieCard,
    IMListApproval,
  },
  data() {
    return {
      i18n: i18n.default,
      title: "Pending Approval",
      listType: "approval",
      dialogType: "spv",
      im: {
        headers: [],
        items: [],
        bisnis_unit: [
          {
            text: "All",
            value: "",
          },
          {
            text: "Other",
            value: "other",
          },
        ],
        paymentHeaders: [
          {
            text: "IM Number",
            value: "imNo"
          },
          {
            text: "Subject",
            value: "imPerihal"
          },
          {
            text: "Submit Date",
            value: "imDate",
          },
          {
            text: "Business Unit",
            value: "imOrganization.name",
          },
          {
            text: "Status",
            value: "imStatus",
            align: "center"
          },
          {
            text: "Actions",
            value: "actions",
          }
        ],
      },
      themeColor: "#fff",
      logoBU: null,
      tableApproval: true,
      tableHistory: false,
      tableRejected: false,
      typeTab: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.im.tableApproval = true;
      axios
        .get(
          process.env.VUE_APP_API +
            `/requests/approval/pending/${this.$route.params.token}?type=pending&query=_&direction=-1&sortBy=imDate&page=1&per_page=8`
        )
        .then((res) => {
          this.im.headers = [
            {
              text: "IM Number",
              value: "imNo",
            },
            {
              text: "Business Unit",
              value: "imOrganization.name",
            },
            {
              text: "Submit Date",
              value: "subtDate",
            },
          ];
          res.data.data.forEach((element) => {
            if (element.imStatus == 3) {
              element.disabled = true;
            }
          });
          this.im.items = res.data.data;
          this.im.jumlah = res.data.total;
          this.im.token_be = res.data.token;

          let dataBu = {
            text: res.data.bu.name,
            value: res.data.bu._id,
          };

          let middle = Math.floor(this.im.bisnis_unit.length / 2);

          this.im.bisnis_unit.splice(middle, 0, dataBu);

          this.themeColor = res.data.bu.hasOwnProperty("settings")
            ? res.data.bu.settings.themeColors
              ? res.data.bu.settings.themeColors
              : "#D42A2A"
            : "#D42A2A";

          if (
            res.data.bu.hasOwnProperty("settings") &&
            res.data.bu.settings.hasOwnProperty("headerLogo") &&
            res.data.bu.settings.headerLogo.src != null
          ) {
            this.logoBU = res.data.bu.settings.headerLogo.src;
          } else {
            this.logoBU = require("../assets/imemo-white.png");
          }
        })
        .catch((err) => {
          
            if ( err.response.data.error == 'invalid token' ) {
              this.$toasted.error("This session is invalid, please check the latest email.", {icon: 'error'});
            } else {
              if(err.response.data.error == 'Forbidden'){
                window.location.href = process.env.VUE_APP_API_OLD+`/redirectError?footerMessage=`+err.response.data.data.footerMessage+`&message=`+err.response.data.data.message+`&logo=`+err.response.data.data.logo
              }else{
                 this.$toasted.error(err.response.data.error, {icon: 'error'});
              }
             
            }
        })
        .finally(() => (this.loading = false));
    },
    getDataHistory() {
      this.im.tableApproval = false;
      axios
        .get(
          process.env.VUE_APP_API +
            `/requests/approval/history/${this.$route.params.token}?type=approved&query=_&direction=-1&sortBy=imDate&page=1&per_page=8`
        )
        .then((res) => {
          this.im.headers = [
            {
              text: "IM Number",
              value: "imNo",
            },
            
            {
              text: "Business Unit",
              value: "imOrganization.name",
            },
            {
              text: "Approved Date",
              value: "subtDateAR",
            },
          ];
          this.im.items = res.data.data;
          this.im.jumlah = res.data.total;
          this.im.token_be = res.data.token;

          let dataBu = {
            text: res.data.bu.name,
            value: res.data.bu._id,
          };

          let middle = Math.floor(this.im.bisnis_unit.length / 2);

          this.im.bisnis_unit.splice(middle, 0, dataBu);

          this.themeColor = res.data.bu.hasOwnProperty("settings")
            ? res.data.bu.settings.themeColors
              ? res.data.bu.settings.themeColors
              : "#D42A2A"
            : "#D42A2A";

          if (
            res.data.bu.hasOwnProperty("settings") &&
            res.data.bu.settings.hasOwnProperty("headerLogo") &&
            res.data.bu.settings.headerLogo.src != null
          ) {
            this.logoBU = res.data.bu.settings.headerLogo.src;
          } else {
            this.logoBU = require("../assets/imemo-white.png");
          }
        })
        .catch((err) => {
          if (err.response.data.error == "invalid token") {
            this.$toasted.error(
              "This session is invalid, please check the latest email.",
              { icon: "error" }
            );
          } else {
            this.$toasted.error(err.response.data.error, { icon: "error" });
          }
        })
        .finally(() => (this.loading = false));
    },
    getDataRejected() {
      this.im.tableApproval = false;
      axios
        .get(
          process.env.VUE_APP_API +
            `/requests/approval/history/${this.$route.params.token}?type=rejected&query=_&direction=-1&sortBy=imDate&page=1&per_page=8`
        )
        .then((res) => {
          this.im.headers = [
            {
              text: "IM Number",
              value: "imNo",
            },
            
            {
              text: "Business Unit",
              value: "imOrganization.name",
            },
            {
              text: "Rejected Date",
              value: "subtDateAR",
            },
          ];

          this.im.items = res.data.data;
          this.im.jumlah = res.data.total;
          this.im.token_be = res.data.token;

          let dataBu = {
            text: res.data.bu.name,
            value: res.data.bu._id,
          };

          let middle = Math.floor(this.im.bisnis_unit.length / 2);

          this.im.bisnis_unit.splice(middle, 0, dataBu);

          this.themeColor = res.data.bu.hasOwnProperty("settings")
            ? res.data.bu.settings.themeColors
              ? res.data.bu.settings.themeColors
              : "#D42A2A"
            : "#D42A2A";

          if (
            res.data.bu.hasOwnProperty("settings") &&
            res.data.bu.settings.hasOwnProperty("headerLogo") &&
            res.data.bu.settings.headerLogo.src != null
          ) {
            this.logoBU = res.data.bu.settings.headerLogo.src;
          } else {
            this.logoBU = require("../assets/imemo-white.png");
          }
        })
        .catch((err) => {
          if (err.response.data.error == "invalid token") {
            this.$toasted.error(
              "This session is invalid, please check the latest email.",
              { icon: "error" }
            );
          } else {
            this.$toasted.error(err.response.data.error, { icon: "error" });
          }
        })
        .finally(() => (this.loading = false));
    },
    getIM() {
      if (this.im.items) {
        for (let i = 0; i < this.im.items.length; i++) {
          this.im.items[i].imStatusLabel =
            this.i18n.status[this.im.items[i].imStatus].name;
          this.im.items[i].imTypeLabel =
            this.i18n.imType[this.im.items[i].imType];
          if (this.im.items[i].imStatus == 2) {
            let workflow = this.im.items[i].imWorkflow;
            for (let j = 0; j < workflow.length; j++) {
              this.im.items[i].imStatusLabel =
                this.i18n.status[this.im.items[i].imStatus].name;
              if (workflow[j].status == 9) {
                this.im.items[i].imStatusLabel =
                  this.i18n.status[workflow[j].status].name;
                break;
              }
            }
          }
          this.im.items[i].imUserName = this.im.items[i].imUser.fullname;

          if (this.im.items[i].hasOwnProperty("imCategory")) {
            for (const data of this.i18n.category) {
              if (data.value == this.im.items[i].imCategory) {
                this.im.items[i].imCategory = data.text;
              }
            }
          } else {
            this.im.items[i].imCategory = "General";
          }
        }
      }
      return this.im;
    },
    getType() {
      if (this.tableApproval) {
        this.type = "pending";
        return this.type;
      }
      if (this.tableHistory) {
        this.type = "approved";
        return this.type;
      }
      if (this.tableRejected) {
        this.type = "rejected";
        return this.type;
      }
    },
  },
};
</script>
<style scoped>
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:last-child, .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row), .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:last-child, .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:not(.v-data-table__mobile-row), .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
  border-top: thin solid rgba(0,0,0,.12);
}

.v-tab.v-tab {
  color: black;
}
.v-tabs__item {
  color: #ffffff;
}

.v-tabs__item--active {
  color: #333;
}
</style>
